export const appRoutes = {
  insured: {
    base: 'autogestion',
  },
  institutional: {
    base: 'institucional',
  },
  survey: {
    base: 'encuesta',
    thankyou: 'gracias'
  }
};
